import { render } from "./ResellerMenu.vue?vue&type=template&id=1703dba8&scoped=true"
import script from "./ResellerMenu.vue?vue&type=script&lang=js"
export * from "./ResellerMenu.vue?vue&type=script&lang=js"

import "./ResellerMenu.vue?vue&type=style&index=0&id=1703dba8&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1703dba8"]])

export default __exports__